import { GET_ENTRY_STRATEGIES, GET_ENTRY_STRATEGIES_ERROR, GET_ENTRY_STRATEGIES_SUCCESS } from './actionTypes';

const initialState = {
  errorGetEntryStrategies: '',
  loadingGetEntryStrategies: false,
  entryStrategies: null,
  successGetEntryStrategies: '',
};

const getEntryStrategies = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTRY_STRATEGIES:
      state = {
        ...state,
        loadingGetEntryStrategies: true,
      };
      break;
    case GET_ENTRY_STRATEGIES_SUCCESS:
      state = {
        ...state,
        loadingGetEntryStrategies: false,
        entryStrategies: action.payload,
        successGetEntryStrategies: action.payload.message,
      };
      break;
    case GET_ENTRY_STRATEGIES_ERROR:
      state = {
        ...state,
        errorGetEntryStrategies: action.payload,
        loadingGetEntryStrategies: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getEntryStrategies;
